import DTConfirmationView from './DTConfirmationView';
import React from 'react';
import { useSelector } from 'react-redux';
import { extractSelectedWizardMacro } from '../../../extractFromState';
import MWResultPage from '../../MacroWizard/MWResultPage/MWResultPage';

const DTConfirmation = (props) => {
  const selectedMacro = useSelector(extractSelectedWizardMacro);

  if (selectedMacro) {
    return <MWResultPage searchResult={selectedMacro} withEdge={props.withEdge} />;
  }

  return <DTConfirmationView {...props} />;
};

export default DTConfirmation;
